'use client';

import { createBrowserClient } from '@supabase/ssr';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL ?? '';
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? '';

const isConfigured =
  supabaseUrl.length > 0 &&
  supabaseAnonKey.length > 0 &&
  !supabaseUrl.includes('dummy') &&
  !supabaseAnonKey.includes('dummy') &&
  !supabaseAnonKey.includes('updateyourkkey');

// Singleton browser client
let _client: ReturnType<typeof createBrowserClient> | null = null;

function getNoopClient() {
  const noop = () => Promise.resolve({ data: null, error: new Error('Supabase is not configured') });
  return {
    auth: {
      getSession: () => Promise.resolve({ data: { session: null }, error: null }),
      onAuthStateChange: (_event: string, _cb: unknown) => ({
        data: { subscription: { unsubscribe: () => {} } },
      }),
      signUp: noop,
      signInWithPassword: noop,
      signOut: () => Promise.resolve({ error: null }),
      getUser: () => Promise.resolve({ data: { user: null }, error: null }),
      signInWithOAuth: noop,
      resetPasswordForEmail: noop,
      updateUser: noop,
      resend: noop,
      verifyOtp: noop,
      exchangeCodeForSession: noop,
    },
    from: () => ({
      select: () => ({ eq: () => ({ single: noop }) }),
      upsert: () => Promise.resolve({ data: null, error: null }),
      insert: () => Promise.resolve({ data: null, error: null }),
      update: () => ({ eq: () => Promise.resolve({ data: null, error: null }) }),
      delete: () => ({ eq: () => Promise.resolve({ data: null, error: null }) }),
    }),
  } as unknown as ReturnType<typeof createBrowserClient>;
}

export function createClient() {
  if (!isConfigured) {
    return getNoopClient();
  }
  if (!_client) {
    _client = createBrowserClient(supabaseUrl, supabaseAnonKey);
  }
  return _client;
}
